import { Globe } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useLanguage } from "@/i18n/LanguageContext";
import { translations, t } from "@/i18n/translations";

const TopBar = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="w-full bg-[hsl(var(--brand-navy))] fixed top-0 z-[60]">
      <div className="container mx-auto px-4 py-2 flex justify-between items-center">
        <div className="flex items-center gap-4">
          <a href="#home" className="flex items-center gap-3">
            <div className="bg-white rounded-xl px-3 py-1.5 shadow-lg shadow-white/15">
              <img
                src="/logo-adw.png"
                alt="A&DW Consulting Logo"
                className="h-9 w-auto cursor-pointer transition-all duration-300 hover:scale-105"
              />
            </div>
            <div className="hidden sm:block">
              <span className="text-white font-bold text-sm tracking-wide">{t(translations.topbar.company, language)}</span>
              <span className="block text-white/60 text-[10px] tracking-widest uppercase">{t(translations.topbar.subtitle, language)}</span>
            </div>
          </a>
        </div>

        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="sm" className="gap-2 text-white/80 hover:text-white hover:bg-white/10">
              <Globe className="h-4 w-4" />
              <span className="font-medium text-xs">{language.toUpperCase()}</span>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end" className="bg-background z-50">
            <DropdownMenuItem onClick={() => setLanguage("fr")} className="cursor-pointer">
              🇫🇷 Français
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => setLanguage("en")} className="cursor-pointer">
              🇬🇧 English
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </div>
  );
};

export default TopBar;
